var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.TextIcon = exports.FeatherIcon = void 0;

var react_1 = __importDefault(require("react"));

var iconMap_1 = require("../svg/feather/iconMap");

var merge_ncss_1 = require("../lib/merge-ncss");

var element_1 = require("./element");

var grid_1 = require("./grid");

var icon_reset_1 = require("./icon-reset");

exports.FeatherIcon = function (props) {
  var iconMap = props.iconMap || iconMap_1.IconMap;

  if (Object.keys(iconMap).includes(props.icon)) {
    var label = {
      ncss: {
        label: 'feather-icon'
      }
    };
    var RenderIcon = iconMap[props.icon];
    var ncss = merge_ncss_1.mergeNcss([label, icon_reset_1.featherIconElementStyle, props.wheel.elementNcss.featherIcon, props.wheel.style, props]);
    return react_1.default.createElement(RenderIcon, {
      ncss: ncss,
      wheel: props.wheel
    });
  } else {
    return react_1.default.createElement("div", null, "Feather icon ", props.icon, " not found");
  }
};

exports.TextIcon = function (props) {
  var label = {
    ncss: {
      label: 'text-icon'
    }
  };
  var attrs = element_1.getElementAttrs(props);
  var ncss = merge_ncss_1.mergeNcss([label, icon_reset_1.textIconElementStyle, props.wheel.elementNcss.textIcon, props.wheel.style, props]);
  return react_1.default.createElement(grid_1.Box, Object.assign({
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: ncss
    })
  }, attrs), props.text);
};

exports.Icon = function (props) {
  if (react_1.default.isValidElement(props.icon)) {
    return props.icon;
  }

  var iconMap = props.customIconMap ? Object.assign(Object.assign({}, iconMap_1.IconMap), props.customIconMap) : iconMap_1.IconMap;

  if (typeof props.icon === 'string') {
    if (Object.keys(iconMap).includes(props.icon)) {
      return react_1.default.createElement(exports.FeatherIcon, {
        iconMap: iconMap,
        icon: props.icon,
        wheel: props.wheel
      });
    } else {
      return react_1.default.createElement(exports.TextIcon, {
        text: props.icon,
        wheel: props.wheel
      });
    }
  }

  return null;
};